
<div v-if="visible" ref="alert" class="cp-alert">
  <div class="box-mask">
    <div class="box-container">
      <div class="box-header">
        <div class="box-title">{{ title }}</div>
      </div>
      <div class="box-content">{{ text }}</div>
      <div class="box-bottom">
        <div class="bottom-item" @click="onClose">确认</div>
      </div>
    </div>
  </div>
</div>
